//Componentes generales
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

// Estilos
import './AddFilter.css';

/* 
    Componente Filtros Avanzados.
    cerrar es la función encargada de ocultar el dialogo.
    filtro es la variable del context que define que requerimientos se muestran.
    aplicarFiltros es la función del context que setea el filtro del context.
*/
function AddFilterSmaller({cerrar, filtro, aplicarFiltros, componentePadre = 'Bar'}) {
  
  //States de Filtro Rango.
  const [filterRango, setFilterRango] = useState(filtro);
  const [periodoBase, setPeriodoBase] = useState(filtro.periodoBase);

  const handleChangePeriodo = (e) => {
    let value = e.target.value.replace(/\D/g, '');;
    let valueToSet = value;
    
    if(value.length > 6) return;

    if(value.length > 2) valueToSet = `${value.slice(0,2)}/${value.slice(2)}`;

    setPeriodoBase(valueToSet)
  }

    /*
        Aplica los filtros seteados llamando a la función del context en views.
        Una vez aplicados, cierra el presente dialogo.
    */
    const handlerAplicaFiltros = () => {
        aplicarFiltros({periodoBase});
        cerrar(null);
    };

  return (
    <div className="container-gr-filter">
      <div className="label-filter-icon-r">
        <div className="filter-title-r">Filtros</div>
        <div className="filter-icon-r">
          <FontAwesomeIcon
            icon={faXmark}
            onClick={() => cerrar(null)}
          />
        </div>
      </div>
      <div>

        {
          componentePadre == "GrillaConsumibles" && <div className="container-periodo">
            <div className="container-gr-subtitles">Período Base</div>
            <input className='inputPeriodoBase' placeholder='01/1990' maxLength={7} value={periodoBase} onChange={(e)=>handleChangePeriodo(e)}/>
          </div>
        }

      </div>
      <div className="container-filter-btn">
        <div
          className="filter-btn"
          onClick={handlerAplicaFiltros}
        >
          Aplicar Filtros
        </div>
      </div>
    </div>
  );
}

export default AddFilterSmaller;
